<script setup lang="ts" generic="T extends { id: string }">
import type { PropType, StyleValue } from 'vue';

import { ref } from 'vue';

defineProps({
  items: {
    type: Array as PropType<Array<T>>,
    required: true,
  },
  minItemWidth: {
    type: Number,
    required: true,
  },
  maxItemWidth: {
    type: Number,
    required: true,
  },
  gap: {
    type: Number,
    default: 20,
  },
  style: {
    type: [Object, String] as PropType<StyleValue>,
    required: false,
  },
  displayScrollbar: {
    type: Boolean,
    default: false,
  },
});

const $container = ref<HTMLElement>();

function scroll(direction: 'left' | 'right') {
  const el = $container.value;
  if (!el)
    return;
  const amount = el.getBoundingClientRect().width * 0.8;
  el.scrollBy({ left: direction === 'right' ? amount : -amount, behavior: 'smooth' });
}

defineExpose({ scroll });
</script>

<template>
  <div
    ref="$container"
    class="carousel-container" :style="{
      gap: `${gap}px`,
    }"
  >
    <div
      v-for="item in items"
      :key="item.id"
      class="carousel-item"
      :style="{ minWidth: `${minItemWidth}px`, maxWidth: `${maxItemWidth}px` }"
    >
      <slot name="item" :item="item">
        {{ item.id }}
      </slot>
    </div>
  </div>
</template>

<style lang="css" scoped>
.carousel-container {
  display: flex;
  overflow-x: scroll;
  padding-bottom: 6px;
  scrollbar-width: none;
  background-color: transparent;
}

.carousel-container::-webkit-scrollbar {
  -webkit-appearance: none;
}
</style>
